import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ba835fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper__character" }
const _hoisted_2 = { class: "wrapper__character__left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "wrapper__character__right" }
const _hoisted_5 = { class: "wrapper__character__right__name" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_7 = { class: "wrapper__character__right__name__title" }
const _hoisted_8 = { class: "wrapper__character__block" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "STATUS", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "GENDER", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "SPECIES", -1))
const _hoisted_12 = { class: "wrapper__character__block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "ORIGIN", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "LOCATION", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "TYPE", -1))

import { Character } from '@/models/character';
import { useRouter } from 'vue-router';
import BaseButton from '@/components/UI/BaseButton.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    character: null
  },
  setup(__props: any) {

const props = __props as { character: Character }

const router = useRouter();
// eslint-disable-next-line


const episodes = `Present in ${props.character.episode.length} ${
  props.character.episode.length < 2 ? 'episode' : 'episodes'
}`;

function goToHome() {
  router.go(-1);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "wrapper__character__left__img",
        src: __props.character.image,
        alt: ""
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseButton, { onClick: goToHome }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.character.name), 1),
        _createElementVNode("p", null, _toDisplayString(episodes))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          _hoisted_9,
          _createElementVNode("p", null, _toDisplayString(__props.character.status), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createElementVNode("p", null, _toDisplayString(__props.character.gender), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("p", null, _toDisplayString(__props.character.species), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _hoisted_13,
          _createElementVNode("p", null, _toDisplayString(__props.character.origin.name), 1)
        ]),
        _createElementVNode("div", null, [
          _hoisted_14,
          _createElementVNode("p", null, _toDisplayString(__props.character.location.name), 1)
        ]),
        (__props.character.type.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("p", null, _toDisplayString(__props.character.type), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})